import { configuration } from 'mmfintech-checkout-commons'
import { isBase64EncodedImage } from 'mmfintech-commons'

import type { SupportedBank } from 'mmfintech-checkout-commons/types'

import BankIcon from '@assets/icons/bank-icon.svg'

type SelectBankIconProps = {
  bank: SupportedBank
}

export const SelectBankIcon = ({ bank }: SelectBankIconProps) => {
  if (bank.logoUrl) {
    return (
      <img
        src={
          isBase64EncodedImage(bank.logoUrl) || bank.logoUrl.startsWith('http')
            ? bank.logoUrl
            : `${configuration.readBackendConfig()}${bank.logoUrl}`
        }
        alt={`${bank.name} icon`}
      />
    )
  }

  return <img src={BankIcon} alt='Bank icon' />
}
